<template>
    <b-col md="8" lg="6" class="lx-billing-card-icons">
        <div class="lx-billing-card-icons__cards w-100">
            <span v-if="showIcons == 'credit-card'">
                <img v-if="isVisaSupported" src="/static/images/cards/visa.svg" alt="Visa" />
                <img v-if="isMastercardSupported" src="/static/images/cards/mastercard.svg" alt="Mastercard" />
                <img
                    v-if="isAmericanExpressSupported"
                    src="/static/images/cards/american-express.svg"
                    alt="American Express"
                />
                <img v-if="isDiscoverSupported" src="/static/images/cards/discover.svg" alt="Discover" />
                <img v-if="isDinersClubSupported" src="/static/images/cards/diners-club.svg" alt="Diners Club" />
            </span>
            <img v-if="showIcons == 'echeck'" class="pr-1" src="/static/images/cards/echeck.png" alt="eCheck" />
            <img
                v-if="showIcons == 'ach-direct-debit'"
                class="pr-1"
                src="/static/images/cards/ach-direct-debit.png"
                alt="ACH Direct Debit"
            />
            <hr v-if="showIcons !== ''" class="lx-billing-card-icons__separator" />
            <div class="lx-billing-card-icons__seal">
                <a
                    href="https://www.rapidscansecure.com/siteseal/Verify.aspx?code=126,725BF4EB30FAFB059CDF8921062C755EF45BA01C"
                    target="_blank"
                    rel="nofollow"
                >
                   <img
                        width="160"
                        height="69"
                        alt="CompliAssure SiteSeal"
                        src="https://www.rapidscansecure.com/siteseal/Seal.aspx?code=126,725BF4EB30FAFB059CDF8921062C755EF45BA01C"
                        border="0"
                    />
                </a>
            </div>            
        </div>
    </b-col>
</template>

<script>
    import isNil from 'lodash/isNil';
    import {
        PAYMENT_CARD_VISA,
        PAYMENT_CARD_MASTERCARD,
        PAYMENT_CARD_AMERICAN_EXPRESS,
        PAYMENT_CARD_DINERS_CLUB,
        PAYMENT_CARD_DISCOVER,
    } from '../../../constants';

    export default {
        props: {
            showIcons: {
                type: String,
                default: 'credit-card',
            },
            acceptedCards: {
                type: Array,
                default: null,
            },
        },
        computed: {
            isVisaSupported() {
                if (isNil(this.acceptedCards)) return true;
                return this.acceptedCards.find((type) => type.id === PAYMENT_CARD_VISA);
            },
            isMastercardSupported() {
                if (isNil(this.acceptedCards)) return true;
                return this.acceptedCards.find((type) => type.id === PAYMENT_CARD_MASTERCARD);
            },
            isAmericanExpressSupported() {
                if (isNil(this.acceptedCards)) return true;
                return this.acceptedCards.find((type) => type.id === PAYMENT_CARD_AMERICAN_EXPRESS);
            },
            isDinersClubSupported() {
                if (isNil(this.acceptedCards)) return true;
                return this.acceptedCards.find((type) => type.id === PAYMENT_CARD_DINERS_CLUB);
            },
            isDiscoverSupported() {
                if (isNil(this.acceptedCards)) return true;
                return this.acceptedCards.find((type) => type.id === PAYMENT_CARD_DISCOVER);
            },
        },
    };
</script>

<style scoped lang="scss">
    @import '~bootstrap/scss/_functions.scss';
    @import '~bootstrap/scss/_variables.scss';
    @import '~bootstrap/scss/mixins/_breakpoints.scss';

    .lx-billing-card-icons {
        display: flex !important;
        align-items: center !important;
        flex-direction: column !important;

        @include media-breakpoint-down(md) {
            margin-top: 1.25rem;
        }

        &__cards {
            img {
                margin-top: 0.3rem;
                width: 60px;
            }
        }

        &__separator {
            margin: 1.5rem 0;
            width: 75%;
        }

        &__seal {
            img {
                margin-top: 0 !important;
                width: 160px;
            }
        }
    }
</style>
